import { filterListStyles } from "@insite/content-library/Widgets/ProductList/ProductListFilterList";
import getProp from "@insite/mobius/utilities/getProp";
import { COLORS, TYPOGRAPHY } from "@tCentro/theme/design";
import { css } from "styled-components";

filterListStyles.filterText = {
    css: css`
        color: ${getProp("theme.typography.p.color")};
        font-weight: ${TYPOGRAPHY.weight.mediumbold};
        font-size: ${TYPOGRAPHY.size.largest};
        padding-bottom: 10px;
    `,
};

filterListStyles.filterTag = {
    css: css`
        display: flex;
        align-items: center;
        button {
            min-width: auto;
            &:hover {
                border: none !important;
                background: none !important;
            }
            &:focus {
                outline: none !important;
            }
        }
    `,
};
